import React, { useEffect, useRef, useState } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ActivateSearchIcon, BackArrowIcon } from "../../Icons";
import ResourceSidebar from "./ResourceSidebar";
import { Tab, Nav } from "react-bootstrap";
import AssignButton from "./AssignButton";
import {
  ALL,
  APPLICATION_TAB_TYPE,
  AR_CONTENT_TAB,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  RESOURCE_SKILL_STREAM_TAB,
} from "../../constant/constants";
import ResourceListPanel from "./ResourceListPanel";
import { checkPermissionExist, toggleArrayByObject, visibleAssignSection } from "../../utils/general";
import { RESOURCE_ASSIGN_PERMISSION, RESOURCE_REVOKE_PERMISSION } from "../../constant/permission";
import bgGrad from "../../assets/img/bgGrad.png";
import ResouceTabData from "./ResourceMobile/ResouceTabData";
import SearchFullScreen from "../../components/ForMobile/SearchFullScreen";
import SearchbarMobile from "../../components/ForMobile/SearchbarMobile";
import ResourceTabData from "./ResourceMobile/ResourceTabData";
import ScrollFixedSearch from "../../components/ForMobile/ScrollFixedSearch";
import { useScrollDirectionClass } from "../../components/ForMobile/useScrollDirectionClass";
import Breadcrumbs from "../../components/Breadcrumb/Breadcrumbs";

const { BackButton, SimCheckBox } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const ResourceManagement = ({ isMobileView }) => {
  // const mobSearchRef = useRef(null);
  // ScrollFixedSearch(mobSearchRef, "scroll-up");

  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const { type } = params;
  const permissionType = type ? RESOURCE_REVOKE_PERMISSION : RESOURCE_ASSIGN_PERMISSION;
  const { uuid } = params;
  const configData = useUnoSelector((state) => state.config);
  const UNO_URL = configData?.config?.UNO_URL;
  const [activeTab, setActiveTab] = useState("");
  const [selectedResource, setSelectedResource] = useState({
    application: [],
    module: [],
  });
  const [selectCheckBoxAll, setSelectCheckBoxAll] = useState(false);
  const [checkBoxAll, setCheckBoxAll] = useState({
    [ALL]: false,
    [RESOURCE_APPLICATION_TAB]: false,
    [RESOURCE_MODULE_TAB]: false,
    [RESOURCE_ENVIRONMENT_TAB]: false,
    [RESOURCE_SKILL_STREAM_TAB]: false,
    [RESOURCE_SKILL_SCHOOL_TAB]: false,
    [AR_CONTENT_TAB]: false,
  });
  const [checkedFilterItem, setCheckedFilterItem] = useState({
    [RESOURCE_APPLICATION_TAB]: [],
    [RESOURCE_MODULE_TAB]: [],
    [RESOURCE_ENVIRONMENT_TAB]: [],
    [RESOURCE_SKILL_STREAM_TAB]: [],
    [RESOURCE_SKILL_SCHOOL_TAB]: [],
    [AR_CONTENT_TAB]: [],
  });

  const [searchMode, setSearchMode] = useState(false);
  const [showBackBtn, setShowBackBtn] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let visibleSectionList = visibleAssignSection();
    setActiveTab(visibleSectionList.length > 0 ? visibleSectionList[0]?.id_link : "");
  }, []);

  const handleItemClick = (active, item) => {
    setActiveTab(item.id_link);
  };
  const handleResetSelectResource = () => {
    setSelectedResource({
      application: [],
      module: [],
    });
  };
  const backClick = () => {
    localStorage.setItem("prevTabHistory", APPLICATION_TAB_TYPE);
    navigate(-1);
  };
  const handleSelectAllTrigger = (status) => {
    setSelectCheckBoxAll(status);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleClickSelectCheckbox = (item) => {
    setCheckedFilterItem((pre) => ({
      ...pre,
      [activeTab]: toggleArrayByObject(pre[activeTab], item),
    }));
  };
  const handleResetCheckBox = () => {
    setCheckedFilterItem((pre) => ({
      ...pre,
      [activeTab]: [],
    }));
  };

  const mobSearchRef = useRef(null);
  ScrollFixedSearch(mobSearchRef, "scroll-up");
  useScrollDirectionClass();

  return (
    <div className="resource-page">
      {!isMobileView ? (
        <div className="page-title with-fuctions">
          <div className="title-here">
            <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
            <div className="title-n-breads-wrapper">
              <div className="title-n-breads">
                <p>Resource Management</p>
                <span className="separator"> {""} </span>
                <Breadcrumbs UNO_URL={UNO_URL} UUID={uuid} activeCrumb={uuid} isUser={false} />
              </div>
            </div>
          </div>

          {checkPermissionExist(permissionType) && (
            <AssignButton
              selectedResource={selectedResource}
              handleResetSelectResource={handleResetSelectResource}
              checkBoxAll={checkBoxAll}
            />
          )}
        </div>
      ) : (
        <></>
      )}

      {!isMobileView ? (
        <div className="resource-body">
          <div className="resource-side">
            <ResourceSidebar
              onHandleSelectTab={handleItemClick}
              UUID={uuid}
              UNO_URL={UNO_URL}
              checkBoxAll={checkBoxAll}
              setCheckBoxAll={setCheckBoxAll}
              handleSelectAllTrigger={handleSelectAllTrigger}
            />
          </div>
          <div className="resource-details">
            <ResourceListPanel
              isMobileView={isMobileView}
              selectCheckBoxAllClicked={selectCheckBoxAll}
              checkBoxAll={checkBoxAll}
              setCheckBoxAll={setCheckBoxAll}
              selectedResource={selectedResource}
              setSelectedResource={setSelectedResource}
              activeTab={activeTab}
              checkedFilterItem={checkedFilterItem}
              setCheckedFilterItem={setCheckedFilterItem}
            />
          </div>
        </div>
      ) : (
        <div className="tab-title-parent">
          <div className={`mob-header ${isScrolled ? "scroll-up" : "compact"}`}>
            <div className={`page-title mob ${!showBackBtn && "with-backBtn"}`}>
              {!showBackBtn && (
                <div className="backButtonWrapper">
                  <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
                </div>
              )}
              <div className="mobSearchParent">
                <SearchbarMobile
                  showFilterBtn={true}
                  activeTab={activeTab}
                  selectedCheckboxes={checkedFilterItem[activeTab]}
                  handleResetCheckBox={handleResetCheckBox}
                  handleSelectApplication={handleClickSelectCheckbox}
                />
              </div>
            </div>
          </div>

          <ResourceTabData
            isMobileView={isMobileView}
            UUID={uuid}
            UNO_URL={UNO_URL}
            onHandleSelectTab={handleItemClick}
            selectCheckBoxAllClicked={selectCheckBoxAll}
            checkBoxAll={checkBoxAll}
            setCheckBoxAll={setCheckBoxAll}
            selectedResource={selectedResource}
            setSelectedResource={setSelectedResource}
            activeTab={activeTab}
            checkedFilterItem={checkedFilterItem}
            setCheckedFilterItem={setCheckedFilterItem}
          />
        </div>
      )}

      {isMobileView && (
        <div className="assignForMob">
          {checkPermissionExist(permissionType) && (
            <AssignButton
              selectedResource={selectedResource}
              handleResetSelectResource={handleResetSelectResource}
              checkBoxAll={checkBoxAll}
              isMobileView={isMobileView}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ResourceManagement;
